import axios from 'axios';
import AuthenticationService from '../services/authentication-service';

const ApiClient = {
    get: async(url) => {
        const headers = {};
        const accessToken = await AuthenticationService.getAccessToken();
        
        if (accessToken) {
            headers.Authorization = `token ${accessToken}`;
        }
        
        return await axios.get(url, { headers });
    }, 
    post : async (url, data) => {
        const accessToken = await AuthenticationService.getAccessToken();
        let payload = {
            method : 'post',
            url : url,
            data: data
        };
        if(accessToken){
            payload.headers = {
                'Authorization': `token ${accessToken}`
            }
        }
        const response = await axios(payload);
        return response;
    }
}

export default ApiClient;